import React from 'react';
import { Navbar } from '../navbar/navbar';
import { BurgerMenuContainer } from '../burger-menu/burger-menu';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Formsy from 'formsy-react';
import { Row, Column, Button, Colors, Sizes } from 'react-foundation';
import { BasicInfo } from './basic-info';
import { Loading } from '../layout/loading';
import { Location } from './location';
import { ChangePasswordModal } from '../create-account/change-password';
import { getProfile } from '../../state/profile/actions';
import { updateProfile } from '../../state/profile/actions';
import { completeAccount } from '../../state/create-account/actions';

const Profile = React.createClass({
  getInitialState() {
    return {
      formValid: false
    };
  },

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getProfile());
  },

  renderNavbar() {
    return (
      <div id="outer-container">
        <BurgerMenuContainer
          pageWrapId={'page-wrap'}
          outerContainerId="outer-container"
        />
        <Navbar {...this.props} title={'My Profile'} />
      </div>
    );
  },

  handleValid() {
    this.setState({ formValid: true });
  },

  handleInvalid() {
    this.setState({ formValid: false });
  },

  submit(formData) {
    const { isNew } = this.props;
    this.props.onSubmit(formData, isNew);
  },

  renderMain() {
    const { profile, isLoading, errors } = this.props;
    const justSaved = this.props.location.search.indexOf('saved') > -1;
    if (isLoading) {
      return <Loading msg="Loading..." />;
    }

    return (
      <div className="profile-container">
        <Formsy.Form
          onValidSubmit={this.submit}
          onValid={this.handleValid}
          onInvalid={this.handleInvalid}
        >
          {justSaved ? (
            <Row isColumn>
              <div className="save-message">
                Your profile was successfully saved!
              </div>
            </Row>
          ) : null}
          {errors ? (
            <Row isColumn>
              <div className="profile-errors">{errors}</div>
            </Row>
          ) : null}
          <Row isColumn>
            <Column small={12} medium={4}>
              <BasicInfo profile={profile} />
            </Column>
            <Column small={12} medium={4}>
              <Location profile={profile} />
            </Column>
            <Column small={12} medium={4} />
          </Row>
          <Row>
            <Column small={8} centerOnSmall>
              <Button
                sizes={Sizes.LARGE}
                color={Colors.PRIMARY}
                className="save-button"
                disabled={!this.state.formValid}
                type="submit"
                isExpanded
              >
                Save
              </Button>
              {!this.state.formValid ? (
                <div className="required-fields-msg error-msg">
                  Please fill out all required fields marked with an asterisk.
                </div>
              ) : null}
            </Column>
          </Row>
        </Formsy.Form>
      </div>
    );
  },

  render() {
    return (
      <div>
        <ChangePasswordModal />
        {this.renderNavbar()}
        {this.renderMain()}
      </div>
    );
  }
});

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.get('isAuthenticated'),
    account: state.auth.get('user'),
    errors: state.profile.get('errors'),
    profile: state.profile.get('profile'),
    isLoading: state.profile.get('isLoading'),
    isNew: state.registration.get('isNew')
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmit: (formData, isNew) => {
    dispatch(updateProfile(formData)).then(response => {
      if (response.ok) {
        dispatch(getProfile());
        if (isNew) {
          dispatch(completeAccount());
          dispatch(push('/create-job'));
        } else {
          dispatch(push('/jobs'));
        }
      }
    });
  },
  dispatch
});

export const ProfileContainer = connect(mapStateToProps, mapDispatchToProps)(
  Profile
);



/** WEBPACK FOOTER **
 ** ./src/components/profile/profile.jsx
 **/